import React, { useState } from "react";
import TableInvoice from "./TableInvoice";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import DOMPurify from "dompurify";

import { Applogo } from "../../../Routes/ImagePath";
import { useGeneratePdf } from "../../../hooks/useGeneratePdf";
import ColorGrowingSpinner from "../../../components/Spinners/ColorGrowingSpinner";
export default function InvoiceStyle({
  lang,
  DEAR,
  TAXNUMBER,
  TAXINVOICENUMBER,
  DATE,
  PAYUNTIL,
  TOTAL,
  NOTE,
  SIGNATURE,
  ORIGINAL,
  name,
  // printRef,
  taxNum,
  address,
  cityAddress,
  phone,
  email,
  logo,
  coData,
  revenues,
  revenuesExempt,
  expenses,
  fixedExpenses,
  list,
  amounts,
  tax,
  discount,
  total,
  information,
  totalAfDiscount,
  perTax,
  dueDate,
  totalAfTax,
  exemptionAmount,
  headerDetails,
  handleDownloadPdf,
  handleSubmit,
  show,
  setShow,
  invoiceNumber,

  dateInvoice,
  showModal,
  setShowModal,
}) {
  //MODAL
  const handleCloseModal = () => setShowModal(false);
  const handleShowModal = () => setShowModal(true);
  const { printRef, generatePdf, printing } = useGeneratePdf();

  const createMarkup = (html) => {
    return {
      __html: DOMPurify.sanitize(html),
    };
  };
  return (
    <div>
      <Modal show={showModal} onHide={0}>
        {/* <Modal.Header closeButton>
          <Modal.Title>Modal heading</Modal.Title>
        </Modal.Header> */}
        <Modal.Body>تم إنشاء الفاتورة</Modal.Body>
        <Modal.Footer>
          <Button
            variant="primary"
            onClick={handleCloseModal}
            href="/invoices-create"
          >
            إنشاء فاتورة جديدة
          </Button>
          <Button variant="info" onClick={handleCloseModal} href="/">
            عودة للصفحة الرئيسية
          </Button>
        </Modal.Footer>
      </Modal>
      <div
        className={`
    ${printing ? "print-style loading-opacity" : ""}
    my-animation card
    ${lang === "en" ? "invoice-en-mk" : ""}
  `.trim()}
      >
        {" "}
        {/* Page Content */}
        <div
          className={printing ? "print-style p-4" : "invoice-mk p-4"}
          ref={printRef}
        >
          {/* Page Header */}
          {/* <div className="header-invoice-mk text-center  ">
        <h1 className='text-primary-black text-primary-black-bold'>ضريبة قيمة مضافة مفصلة </h1>
      
      </div> */}
          <div className="d-flex justify-content-between card-header pt-4">
            <div
              className={
                lang === "en"
                  ? "header-address-en-mk "
                  : "header-address-mk col-md-4 "
              }
            >
              <h4 className="h-black-mk invoce-co-name-mk ">
                الشركة : {headerDetails.companyName}
              </h4>
            </div>

            <div className="logo-div-mk text-center col-md-4">
              <img
                src={Applogo}
                className="logo"
                style={{ marginTop: "0px", height: "50px", width: "50px" }}
              />
            </div>
            <div
              className={
                lang === "en"
                  ? "header-address-en-mk "
                  : "header-address-mk col-md-4 "
              }
            >
              <h4 className="h-black-mk text-start">
                {" "}
                نسبة سلفيات ضريبة الدخل :{" "}
                {headerDetails.taxRate ? headerDetails.taxRate : 0} %
              </h4>
            </div>
          </div>

          <div className="title-invoice-mk border-div primary d-flex justify-content-between">
            <div className="right">
              <h3 className="h-black-mk"> # {headerDetails.companyNumber}</h3>

              {/* <h3 className='bold h-black-mk'>{TOTAL} {total.toLocaleString()} <BiShekel /></h3> */}
            </div>
            <div className="center">
              {/* <h3 className="h-black-mk invoce-co-name-mk bold" >{headerDetails.companyName}</h3> */}
              <h3 className="h-black-mk invoce-co-name-mk bold">
                {" "}
                قيود الفترة الضريبية{" "}
                <span className="text-primary me-2">
                  {" "}
                  {headerDetails.year} - {headerDetails.month}
                </span>
              </h3>
              {/* <h3 className='bold h-black-mk'> {TAXINVOICENUMBER} {invoiceNumber }</h3>
          <h4 className="bold h-black-mk">{ORIGINAL} </h4> */}
            </div>
            <div className={lang === "en" ? "left-en" : ""}>
              {/* <h4 className="h-black-mk left"  >  {headerDetails.year} - {headerDetails.month}</h4> */}

              {/* <h4 className="h-black-mk"> <span> {DATE} {headerDetails.year} - {headerDetails.month} </span>{dateInvoice}</h4>
          <h4 className="h-black-mk"> <span>{PAYUNTIL} </span>{dueDate}</h4> */}
            </div>
          </div>
          {/* /Page Header */}
          <div className="">
            <div className="">
              <div
              //onSubmit={handleSubmit}
              >
                <div className="row ">
                  <div className="col-md-12 col-sm-12">
                    {/* ---------------------- Table Invoice -------------------------- */}
                    <TableInvoice
                      list={list}
                      amounts={amounts}
                      tax={tax}
                      discount={discount}
                      total={total}
                      information={information}
                      totalAfDiscount={totalAfDiscount}
                      perTax={perTax}
                      dueDate={dueDate}
                      lang={lang}
                      totalAfTax={totalAfTax}
                      exemptionAmount={exemptionAmount}
                    />

                    <div className="row ">
                      <hr></hr>
                      <div className="col-sm-12 col-md-9">
                        <div
                          className={
                            lang === "en"
                              ? "form-group description-en-mk"
                              : "form-group description-mk"
                          }
                        >
                          <label
                            className="h-black-mk bold"
                            dangerouslySetInnerHTML={createMarkup(NOTE)}
                          ></label>
                          <div className=" information-mk">{information}</div>
                        </div>
                      </div>
                      <div className="col-sm-12 col-md-3 text-right">
                        <div
                          className={
                            lang === "en" ? "signature-en-mk" : "signature-mk"
                          }
                        >
                          <h4 className="h-black-mk bold"> {SIGNATURE} </h4>
                          {/* <div className=" information-mk">{information}</div> */}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className={printing ? "d-none" : "submit-section pb-4 mb-4"}>
          <button
            className="btn btn-back-mk submit-btn   btn btn-rounded btn-dark me-2"
            data-tip
            data-for="pdf-tip"
            onClick={() => {
              // handleDownloadPdf();
              generatePdf(`" تقرير كشف دوري"`);
              // handleSubmit();
            }}
          >
            طباعة PDF
          </button>
          <button
            className="btn btn-back-mk submit-btn btn btn-rounded btn-dark me-2"
            onClick={() => setShow(!show)}
          >
            حفظ مسودة{" "}
          </button>
          <button
            className="btn btn-back-mk submit-btn btn btn-rounded btn-dark me-2"
            onClick={() => setShow(!show)}
          >
            رجوع{" "}
          </button>
        </div>
      </div>
      {printing && (
        <div className="row">
          <ColorGrowingSpinner
            intensityLevels={[0.4, 0.6, 0.8, 0.9, 1]} // Opacity levels for #ff9b44
          />
        </div>
      )}
    </div>
  );
}
